import { IconCodeEditorOutline18 as CodeEditorIcon } from "nucleo-ui-outline-18"

import type { SlashCommandDefinition } from "../types"
import { iconClassName } from "../constants"

export const codeGroupCommand: SlashCommandDefinition = {
	key: "code-group",
	title: "Code group",
	icon: <CodeEditorIcon strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).insertCodeGroup().run()
	},
	group: "blocks",
	aliases: ["code group", "codegroup", "languages", "snippets", "tabs"],
}
